import React from "react";
import Navbar from "../components/NavbarOutside";
import { useLocation, useParams } from "react-router-dom";

function OutsideLayout(props) {
  const { quizId, reportId } = useParams();
  const routesWithoutNavbar = [
    `/base_quizzes/${quizId}`,
    `/consult-report/${reportId}`,
  ];
  const { pathname } = useLocation();
  const shouldInclude = !routesWithoutNavbar.includes(pathname);
  return (
    <div>
      {shouldInclude && <Navbar layout="outside" />}

      <div
        style={{
          flex: 1,
          flexGrow: 1,
          height: shouldInclude ? "calc(100vh - 85px)" : "100vh",
          overflow: "auto",
          maxWidth: "100%",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default OutsideLayout;
